var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "x-tel-input" },
    [
      _vm.label
        ? _c("label", [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "VueTelInput",
        _vm._b(
          {
            class: { error: _vm.error },
            attrs: { value: _vm.tel, placeholder: "" },
            on: { input: _vm.onChange }
          },
          "VueTelInput",
          _vm.$attrs,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }